import _ from 'lodash';
import { AcademyAssessment } from './academy-assessment';
import { AcademyModule } from './academy-module';
import { UserRiseAssessment } from './user-rise-assessment';

export class AcademyCourse {
	public id: number;
	public iconUrl: string;
	public header: string;
	public oneLiner: string;

	public modules: AcademyModule[];
	public assessments: AcademyAssessment[];

	// progress tracking
	public totalLessons: number;
	public completedLessons: number;
	public totalAssessments: number;
	public completedAssessments: number;

	constructor(data: AcademyCourse) {
		Object.assign(this, data);

		this.modules = data.modules.map(m => new AcademyModule(m));
	}

	public setProgress(
		completedLessons: Record<number, boolean>,
		completedAssessments: { academyAssessmentId: number; latestAssessment: UserRiseAssessment }[],
	) {
		const lessonsInCourse = _.flatMap(this.modules, m => m.lessons);
		this.totalLessons = lessonsInCourse.length;
		this.completedLessons = lessonsInCourse.filter(l => completedLessons[l.id]).length;

		const assessmentsInCourse = _.flatMap(this.assessments, a => a);
		this.totalAssessments = assessmentsInCourse.length;
		this.completedAssessments = assessmentsInCourse.filter(a => completedAssessments.some(c => c.academyAssessmentId === a.id)).length;

		this.modules.forEach(module => {
			module.setProgress(completedLessons);
		});
	}
}
